/**
 * Application constants
 */

// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user'
};

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    ME: '/auth/me'
  },
  USERS: {
    BASE: '/users',
    BY_ID: (id) => `/users/${id}`
  },
  INVENTORY: {
    BASE: '/inventory',
    BY_ID: (id) => `/inventory/${id}`
  }
};

// Pagination defaults
export const PAGINATION_DEFAULTS = {
  USERS: [5, 10, 25, 50],
  INVENTORY: [10, 20, 50, 100]
};

// Validation limits
export const VALIDATION_LIMITS = {
  USERNAME: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 50
  },
  PASSWORD: {
    MIN_LENGTH: 6,
    MAX_LENGTH: 100
  },
  EMAIL: {
    MAX_LENGTH: 255
  }
};

// Status codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
};

// Currency configuration
// export const CURRENCY_CONFIG = {
//   DEFAULT_CURRENCY: 'USD',
//   CURRENCY_LOCALE: 'en-US'
// };
export const CURRENCY_CONFIG = {
  DEFAULT_CURRENCY: 'GTQ',
  CURRENCY_LOCALE: 'es-GT'
};

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  LANGUAGE: 'language'
};